import React from 'react'

import Context from './Context'
import firebase from '../../firebase/firebase'
import { auth } from '../../firebase'

const INITIAL_STATE = {
  uid: null,
  token: null,
  email: null,
  admin: false,
  client: false,
  loaded: false
}

const withAuthentication = (Component) => {
  return class WithAuthentication extends React.PureComponent {
    state = INITIAL_STATE

    _b64DecodeUnicode = (str) =>
      decodeURIComponent(Array.prototype.map.call(atob(str), (c) =>
        '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      ).join(''))

    _refreshToken = () => {
      // When token in state is expired we need to get the new one, App will
      // only re-render if the token has actually changed
      auth.getIdToken().then(token =>
        this.setState({token})
      )
    }

    _resetState = async user => {
      if (!user) return this.setState({...INITIAL_STATE, loaded: true})

      try {
        const token = await auth.getIdToken()
        const payload = await JSON.parse(this._b64DecodeUnicode(token.split('.')[1]))

        this.setState({
          uid: user.uid,
          token,
          email: user.email,
          admin: !!payload['admin'],
          client: !!payload['client'],
          loaded: true
        })
      } catch (error) {
        console.log(error)
      }
    }

    componentDidMount () {
      firebase.auth().onAuthStateChanged(async user => await this._resetState(user))
    }

    render () {
      const value = {...this.state, refreshToken: this._refreshToken}
      return (
        <Context.Provider value={{...value}}>
          <Component {...value} />
        </Context.Provider>
      )
    }
  }
}

export default withAuthentication


// WEBPACK FOOTER //
// ./src/components/Users/withAuthentication.js